/* eslint-disable @typescript-eslint/no-require-imports */
/* eslint-disable @typescript-eslint/no-explicit-any */
import React, {useCallback, useEffect} from 'react';
import {
  Dimensions,
  Linking,
  Platform,
  ScrollView,
  Text,
  View,
} from 'react-native';
import {connect} from 'react-redux';

import {
  useFocusEffect,
  useNavigation,
  useRoute,
} from '@react-navigation/native';
import dayjs from 'dayjs';
import 'dayjs/locale/fr';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import {
  addThousandSeparator,
  decodeStringWithAccents,
  formatDateTo,
} from '../../../../common/utils/functions';
import config from '../../../../data/config';
import {initModalData} from '../../../../data/constants/Assurance/AssuranceVoyage/souscription';
import {BREAKPOINT} from '../../../../data/constants/screen';
import {ApiResponse} from '../../../../data/types/interface/api';
import {ContratRapatriement} from '../../../../data/types/interface/Assurance/AssuranceRapatriement';
import {BeneficiaireRapatriement} from '../../../../data/types/interface/Assurance/AssuranceRapatriement/devis';
import {ModalDataDTO} from '../../../../data/types/interface/Assurance/AssuranceVoyage/souscription';
import {RapatriementServices} from '../../../../services/applicatif/rapatriement';
import mapDispatchToProps from '../../../../services/redux/mapDispatchToProps';
import mapStateToProps from '../../../../services/redux/mapStateToProps';
import {MoreInfo} from '../../../components/Assurance/Voyage/MoreInfo';
import {
  BoxShadowed,
  DetailAssuranceContainer,
} from '../../../components/AssuranceRapatriement';
import {buttonsStyles} from '../../../components/Button/boutonStyle';
import PrimaryButton from '../../../components/Button/PrimaryButton';
import DisplayImage from '../../../components/DisplayImage';
import {HeaderScreen} from '../../../components/Header/HeaderScreen';
import Label from '../../../components/Label';
import {LinkWithIconDownload} from '../../../components/Link';
import {Loader} from '../../../components/Loader';
import ConfirmationModal from '../../../components/Modal/ConfirmationModal';
import {ProduitItem} from '../../../components/ProduitItem';
import {styles} from './styles';
dayjs.extend(customParseFormat);

interface DetailContratRapatriementProps {
  user: any;
  // eslint-disable-next-line @typescript-eslint/no-unsafe-function-type
  getAgence?: Function;
}
const DetailContratRapatriementFC = ({
  user,
}: DetailContratRapatriementProps) => {
  const currentUser = user?.data?.utilisateur;
  const windowWidth = Dimensions.get('window').width;
  const [detailContrat, setDetailContrat] = React.useState<
    ContratRapatriement | undefined
  >(undefined);
  const [isLoading, setIsLoading] = React.useState<boolean>(false);
  const [status, setStatus] = React.useState<boolean>(false);
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [modalData, setModalData] = React.useState<ModalDataDTO>({
    ...initModalData,
  });
  const [isOpened, setIsOpened] = React.useState<boolean>(false);

  const {params}: any = useRoute();
  const {navigate}: any = useNavigation();
  const {
    detailContrat: getDetailContrat,
    getTemporaryAttestationToken,
    getTemporaryFraisFuneraireRapatriementToken,
  } = RapatriementServices();
  useFocusEffect(() => {
    if (!currentUser) {
      navigate('Login', {
        data: 'DetailsContratRapatriement',
        params,
      });
    }
  });

  const buttonActions = React.useMemo<Array<any>>(() => {
    const list: Array<any> = [];

    if (
      detailContrat?.status !== 'resilier'
      // dayjs().isBefore(dayjs(detailContrat?.dateEffet, 'DD/MM/YYYY'))
    ) {
      list.push({
        libelle: 'Demander avenant',
        destinationPage: 'DemanderAvenant',
        id: '1',
        imageUrl: 'edit-3.png',
      });
    }

    return list;
  }, [detailContrat]);

  const handleGetDetailContrat = useCallback((id: string) => {
    setIsLoading(true);

    getDetailContrat(id)
      .then((res: ApiResponse) => {
        setIsLoading(false);
        if (res && !res.isError && res?.data) {
          setDetailContrat(res.data);
        }
      })
      .catch((error: any) => {
        console.log('error', error);
        setIsLoading(false);
      });
  }, []);

  useEffect(() => {
    handleGetDetailContrat(params.id);
  }, [params.id]);

  const exportAttestation = useCallback(
    (benef: BeneficiaireRapatriement, type: 'certificat' | 'attestation') => {
      if (detailContrat?.policyNumber) {
        const modalError = {
          status: true,
          title: 'Erreur',
          content: `Erreur lors de l'exportation de l'attestation`,
          btn1: 'Fermer',
          btn2: '',
          handleBtn1: () => {
            setModalData(() => initModalData);
          },
          handleBtn2: () => {},
        };

        let request;
        if (type == 'attestation') {
          request = getTemporaryAttestationToken(
            detailContrat.policyNumber,
            detailContrat.dateEffet,
            detailContrat.dateEcheance as string,
            benef,
          );
        } else if (type == 'certificat') {
          request = getTemporaryFraisFuneraireRapatriementToken(
            detailContrat.policyNumber,
            benef,
          );
        }
        if (request) {
          request
            .then(res => {
              if (res.info) {
                const url = `${config.baseURL}api/common/pdf-generator/link/${res.info}`;

                if (Platform.OS === 'web') {
                  const link = document.createElement('a');
                  link.href = url;
                  link.setAttribute('target', `_blank`);
                  document.body.appendChild(link);
                  link.click();
                  document.body.removeChild(link);
                } else {
                  Linking.openURL(
                    `${config.baseURL}api/common/pdf-generator/link/${res.info}`,
                  );
                }
              } else {
                setModalData(() => modalError);
              }
            })
            .catch(err => {
              console.log(err);
              setModalData(() => ({
                ...modalError,
                content: err.message || modalError.content,
              }));
            });
        }
      }
    },
    [detailContrat?.policyNumber],
  );

  const handleRenouvelerContrat = useCallback(() => {
    const params = {
      contrat: detailContrat?.id,
      numeroPolice: detailContrat?.policyNumber,
      beneficiaires: detailContrat?.beneficiaires,
      simulationId: detailContrat?.simulationId,
      dateDebut: dayjs(detailContrat?.dateEcheance, 'DD/MM/YYYY')
        .startOf('day')
        .add(1, 'day')
        .toDate(),
    };
    navigate('SouscriptionAssuranceRapatriement', params);
  }, [detailContrat]);

  return (
    <View style={{flex: 1, backgroundColor: 'white'}}>
      <HeaderScreen
        title={`POLICE N° ${params.id}`}
        type="ChangeScreen"
        action={() => navigate('MesContrats')}
        noBreadcrumb={false}
      />

      {isLoading ? <Loader /> : null}

      {!isLoading && status ? (
        <ConfirmationModal
          title="Erreur"
          content="Erreur lors de la recuperation de données."
          btn1="OK"
          handleBtn1={() => {
            handleGetDetailContrat(params?.id);
            setStatus(false);
          }}
        />
      ) : null}
      {!isLoading && detailContrat ? (
        <ScrollView style={{flex: 1}}>
          <View
            style={[
              {
                paddingHorizontal:
                  Dimensions.get('window').width < BREAKPOINT.sm ? 20 : 40,
                maxWidth: 1025,
                width: '100%',
                paddingTop: 40,
                backgroundColor: 'white',
                margin: 'auto',
              },
            ]}>
            {/* TODO: test - uncomment */}
            {detailContrat.is_ending ? (
              <View
                style={[
                  {
                    padding: 20,
                    backgroundColor: 'pink',
                    borderRadius: 10,
                  },
                ]}>
                <Text
                  style={{
                    color: '#16599c',
                    fontWeight: 'bold',
                  }}>{`${'Renouvelable'}`}</Text>
                <Text
                  style={{
                    color: 'black',
                    marginTop: 10,
                  }}>{`POLICE N° ${detailContrat.policyNumber}`}</Text>
                <Text
                  style={{
                    color: 'black',
                    marginTop: 10,
                  }}>{`Montant: ${Math.ceil(detailContrat.primeTTC)}Ar`}</Text>

                {/* TODO: test - uncomment */}
                {dayjs().isAfter(
                  dayjs(detailContrat.dateEcheance, 'DD/MM/YYYY').add(
                    1,
                    'month',
                  ),
                  'day',
                ) ? null : (
                  <View
                    style={{
                      marginTop: 20,
                      alignItems: 'center',
                    }}>
                    <PrimaryButton
                      onPress={() => handleRenouvelerContrat()}
                      styleBtnTxt={buttonsStyles.btnValider}
                      styleBtnOuter={buttonsStyles.btnValiderOuter}
                      title={'Renouveler contrat'}
                      type="valider"
                    />
                  </View>
                )}
              </View>
            ) : null}
          </View>
          <DetailAssuranceContainer>
            <Label
              style={{marginHorizontal: 20, marginBottom: 20}}
              title={`${
                detailContrat.status === 'resilier'
                  ? 'Ce contrat a été résilié'
                  : ''
              }`}
              type="fourthTitle"
            />
            <BoxShadowed>
              <Label
                style={{paddingBottom: 10}}
                title="Résumé de votre contrat"
              />

              <View>
                <Label title={`Date d'effet du contrat`} type="titleGreen14" />
                <Label
                  title={`${formatDateTo(
                    detailContrat.dateEffet,
                    'DD/MM/YYYY',
                  )} au ${formatDateTo(
                    detailContrat.dateEcheance,
                    'DD/MM/YYYY',
                  )}`}
                />
              </View>
              <View>
                <Label title={'Police N° :'} type="titleGreen14" />
                <Label title={`${detailContrat.policyNumber}`} />
              </View>
            </BoxShadowed>

            <View>
              <ProduitItem
                data={{items: buttonActions}}
                idContrat={detailContrat.policyNumber}
                isDetailContrat={true}
                typeContrat={'rapatriement'}
                agenceAro={detailContrat.agence}
              />
            </View>

            <View style={{paddingHorizontal: 10}}>
              <LinkWithIconDownload
                text="Notice d'information.pdf"
                url={config.noticeRapatriement}
              />
            </View>

            <MoreInfo
              status={isOpened}
              onCollapse={() => setIsOpened(!isOpened)}>
              <View>
                {detailContrat.beneficiaires?.map(currentAssured => {
                  return (
                    <BoxShadowed
                      key={`benficiaire_${currentAssured.id}`}
                      style={
                        Platform.OS === 'web'
                          ? {
                              flexDirection: 'row',
                              justifyContent: 'space-between',
                              alignItems: 'center',
                            }
                          : {}
                      }>
                      <View>
                        <Label title="Bénéficiaire" />
                        <View>
                          <Label title={'Nom :'} type="titleGreen14" />
                          <Label
                            title={decodeStringWithAccents(currentAssured.nom)}
                          />
                        </View>
                        <View>
                          <Label title={'Prénom :'} type="titleGreen14" />
                          <Label
                            title={decodeStringWithAccents(
                              currentAssured.prenom,
                            )}
                          />
                        </View>
                        <View>
                          <Label title={'Sexe :'} type="titleGreen14" />
                          <Label title={currentAssured.sexe} />
                        </View>
                        <View>
                          <Label
                            title={'Date de naissance :'}
                            type="titleGreen14"
                          />
                          <Label
                            title={dayjs(
                              currentAssured.dateNaissance,
                              'YYYY-MM-DD',
                            ).format('DD/MM/YYYY')}
                          />
                        </View>
                        <View>
                          <Label title={'E-mail :'} type="titleGreen14" />
                          <Label
                            title={decodeStringWithAccents(
                              currentAssured.email,
                            )}
                          />
                        </View>
                        <View>
                          <Label
                            title={'Pays de résidence :'}
                            type="titleGreen14"
                          />
                          <Label
                            title={decodeStringWithAccents(
                              currentAssured.paysResidence,
                            )}
                          />
                        </View>
                        <View>
                          <Label
                            title={'Adresse postale :'}
                            type="titleGreen14"
                          />
                          <Label
                            title={decodeStringWithAccents(
                              currentAssured.adressePostale,
                            )}
                          />
                        </View>
                        <View>
                          <Label
                            title={`Numéro de carte d'identité : `}
                            type="titleGreen14"
                          />
                          <Label title={currentAssured.numCI} />
                        </View>
                        <View>
                          <Label
                            title={'Numéro de téléphone :'}
                            type="titleGreen14"
                          />
                          <Label title={currentAssured.telephone} />
                        </View>
                        {detailContrat?.status !== 'resilier' && (
                          <View
                            style={{
                              display: 'flex',
                              flexDirection: 'column',
                            }}>
                            <LinkWithIconDownload
                              text="Certificat de frais funéraire.pdf"
                              onPress={() => {
                                exportAttestation(currentAssured, 'certificat');
                              }}
                            />
                            <LinkWithIconDownload
                              text="Attestation.pdf"
                              onPress={() => {
                                exportAttestation(
                                  currentAssured,
                                  'attestation',
                                );
                              }}
                            />
                          </View>
                        )}
                      </View>
                      <View>
                        <DisplayImage
                          url={`repatrius/files/content/${currentAssured.capture_file}`}
                          style={
                            Platform.OS === 'web'
                              ? {
                                  width: 400,
                                  height: 250,
                                  resizeMode: 'contain',
                                }
                              : {
                                  width: '100%',
                                  height: 250,
                                  resizeMode: 'contain',
                                }
                          }
                        />
                      </View>
                    </BoxShadowed>
                  );
                })}

                <BoxShadowed>
                  <Label title="Souscripteur" />
                  <View>
                    <Label title={'Nom :'} type="titleGreen14" />
                    <Label title={currentUser?.nom} />
                  </View>
                  <View>
                    <Label title={'Prénom :'} type="titleGreen14" />
                    <Label title={currentUser?.prenom} />
                  </View>
                  <View>
                    <Label title={'Email'} type="titleGreen14" />
                    <Label title={currentUser?.email} />
                  </View>
                </BoxShadowed>

                <View style={{padding: 10}}>
                  <View style={styles.resultContainer}>
                    <View style={{alignItems: 'center'}}>
                      <Text
                        style={[
                          styles.resultMontant,
                          {width: 250, textAlign: 'center'},
                        ]}>{`${
                        detailContrat.primeTTC
                          ? addThousandSeparator(
                              Math.ceil(detailContrat.primeTTC),
                            )
                          : ''
                      } Ar`}</Text>
                    </View>
                  </View>
                </View>
              </View>
            </MoreInfo>

            <View style={{height: 50}} />
          </DetailAssuranceContainer>
        </ScrollView>
      ) : null}

      {modalData.status ? (
        <ConfirmationModal
          contentStyle={
            {
              textAlign: 'left',
              maxHeight: 200,
              overflow: Platform.OS === 'web' ? 'auto' : 'scroll',
            } as any
          }
          title={modalData.title}
          content={modalData.content}
          btn1={modalData.btn1}
          btn2={modalData.btn2}
          handleBtn1={modalData.handleBtn1}
          handleBtn2={modalData.handleBtn2}
          childContainerStyle={{height: '80%'}}
          children={modalData.children}
          modalViewStyle={[
            {maxWidth: windowWidth > 800 ? 800 : '90%'},
            Platform.OS === 'web' && {
              maxHeight: '95%',
            },
          ]}
          titleStyle={{maxWidth: windowWidth > 800 ? 800 : '90%'}}
        />
      ) : null}
    </View>
  );
};

export const DetailContratRapatriement: any = connect(
  mapStateToProps,
  mapDispatchToProps,
)(DetailContratRapatriementFC);

export default DetailContratRapatriement;
